var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form-control', {
    class: _vm.classes,
    attrs: {
      "field": _vm.field
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(api) {
        return [_c('v-radio', {
          attrs: {
            "readonly": api.isReadonly() || _vm.readonly,
            "disabled": _vm.disabled,
            "value": api.getValue(),
            "clickEvent": _vm.clickEvent,
            "data": _vm.data,
            "caption": _vm.caption,
            "label": _vm.label,
            "error": api.getTouched() ? api.getError() : undefined
          },
          on: {
            "input": api.setValue,
            "blur": api.setTouched
          }
        })]
      }
    }])
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06568d2c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/appComponents/components/Form/FormRadio.vue
// module id = 697
// module chunks = 0